




































































import { Component, Vue } from 'vue-property-decorator'
import { ActionTypes } from '@/store/action-types'
import { MutationTypes } from '@/store/mutation-types'
import { ROLE_ADMIN } from '@/utils/constants'
import ApiClient from '@/services/api-client'

@Component({
  name: 'Tools',
  components: {}
})
export default class Tools extends Vue {
  public ROLE_ADMIN = ROLE_ADMIN

  private editorialProjectsProductCodes = []
  private editorialProjectsStaticNodes = []

  created() {
    this.loadEditorialProjects()
  }

  get editorialProjects() {
    return this.$store.getters.editorialProjects
  }

  private async loadEditorialProjects() {
    this.$store.dispatch(ActionTypes.LOAD_EDITORIAL_PROJECTS)
  }

  private async regenerateProductCodes() {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    const payload = {
      editorialProjects: this.editorialProjectsProductCodes
    }
    ApiClient.regenerateProductCodesGlobal(payload).then(() => {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('tools_view.regenerate_product_code.title'),
        variant: 'success',
        message: `${this.$t('tools_view.regenerate_product_code.feedback_success')}`
      })
      this.$store.commit(MutationTypes.SET_LOADING, false)
    }).catch(() => {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('tools_view.regenerate_product_code.title'),
        variant: 'danger',
        message: `${this.$t('tools_view.regenerate_product_code.feedback_error')}`
      })
      this.$store.commit(MutationTypes.SET_LOADING, false)
    })
  }

  private async regenerateStaticNodes() {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    const payload = {
      editorialProjects: this.editorialProjectsStaticNodes
    }
    ApiClient.regenerateStaticNodesGlobal(payload).then(() => {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('tools_view.regenerate_static_nodes.title'),
        variant: 'success',
        message: `${this.$t('tools_view.regenerate_static_nodes.feedback_success')}`
      })
      this.$store.commit(MutationTypes.SET_LOADING, false)
    }).catch(() => {
      this.$store.dispatch(ActionTypes.SHOW_TOAST, {
        title: this.$t('tools_view.regenerate_static_nodes.title'),
        variant: 'danger',
        message: `${this.$t('tools_view.regenerate_static_nodes.feedback_error')}`
      })
      this.$store.commit(MutationTypes.SET_LOADING, false)
    })
  }
}
